import { Modal } from "./modal";

export interface HelpDialogProps {
  readonly onClose: () => void;
}

const shortcuts = [
  ["1–0", "Select, shapes, arrow, line, draw, text, image, and eraser"],
  ["⌘/Ctrl + C / V", "Copy or paste editable elements and local images"],
  ["⌘/Ctrl + Shift + C", "Copy selection or board as PNG"],
  ["⌘/Ctrl + Shift + E", "Open flattened export"],
  ["⌘/Ctrl + S", "Flush autosave now"],
  ["Space + drag", "Pan the canvas"],
  ["?", "Open this help"],
] as const;

/** Explains the local product model, privacy boundary, and normative shortcuts. */
export function HelpDialog({ onClose }: HelpDialogProps) {
  return (
    <Modal title="Shotboard help" titleId="help-title" onClose={onClose}>
      <div className="help-content">
        <section>
          <h3>Editable boards and exports</h3>
          <p>
            Boards retain original pixels and editable annotations in your workspace. PNG and SVG
            exports are flattened, newly encoded copies.
          </p>
        </section>
        <section className="redaction-note">
          <h3>Opaque Redaction</h3>
          <p>
            The preset safely hides covered pixels in flattened exports. It does not remove original
            pixels from an editable board, so do not share the board folder as a redacted artifact.
          </p>
        </section>
        <section>
          <h3>Workspace and recovery</h3>
          <p>
            Your selected folder is canonical. Shotboard never uploads it. If permission or saving
            fails, keep the tab open and use the visible recovery action.
          </p>
        </section>
        <section>
          <h3>Shortcuts</h3>
          <dl className="shortcut-list">
            {shortcuts.map(([keys, action]) => (
              <div key={keys}>
                <dt>{keys}</dt>
                <dd>{action}</dd>
              </div>
            ))}
          </dl>
        </section>
      </div>
    </Modal>
  );
}
